import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Spacer from '../components/spacer'
import * as actions from '../actions/search'
import * as cartActions from '../actions/cart'
import * as settingsActions from '../actions/settings'
import PageTitle from '../components/page-title'
import CompareModal from '../components/compare-modal'
import SearchFilters from '../components/search-filters'
import SearchResults from '../components/search-results'
import {
  getSelectedDiamondPrices,
  getSuppliersForSelect,
  getSelectedAddableDiamonds
} from '../selectors/search'

export const mapStateToProps = (state, ownProps) => {
  return {
    ...state.diamondSearch,
    ...state.settings,
    selectedDiamondPrices: getSelectedDiamondPrices(state),
    suppliersList: getSuppliersForSelect(state),
    addableDiamonds: getSelectedAddableDiamonds(state)
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeFilterVal: (key, val) => {
      dispatch(actions.setFilterVal(key, val))
      // key is 'matched_sets', and value is 'true', then set 'sort_by_field' to 'Pair Sort ID Hash'
      if (key === 'matchedsets') {
        if (val) {
          dispatch(actions.setFilterVal('sortByField', 'Pair Sort ID Hash'))
        } else {
          dispatch(actions.setFilterVal('sortByField', 'Sale Price CAD'))
        }
      }
      if (key === 'diamondType') {
        if (val === 'natural') {
          const filterValues = {
            supplierTypes: ['primary'],
            suppliers: [],
            canadaorigin: false,
            locations: [],
            withImage: true,
            gradingreports: ['GIA', 'AGS']
          }
          dispatch(actions.setFilterValues(filterValues))
        } else if (val === 'lgd') {
          const filterValues = {
            supplierTypes: ['primary'],
            suppliers: [],
            canadaorigin: false,
            locations: [],
            withImage: true,
            gradingreports: ['GIA', 'AGS', 'IGI'],
            colour: [0, 4], // D - G
            clarity: [0, 5] // FL - VS1
          }
          dispatch(actions.setFilterValues(filterValues))
        }
      }
      // do not search if:
      // key is not 'serialnumbers' AND key is not 'labreports' AND value is an array AND has empty strings as for at least one value
      // key is not 'serialnumbers' AND key is not 'labreports' AND value is empty string
      if (((key !== 'serialnumbers' && key !== 'labreports' && Array.isArray(val) && val.filter(num => num === '').length > 0) || (val === '' && key !== 'serialnumbers' && key !== 'labreports'))) {
        return
      }
      dispatch(actions.setPageAndsearch())
    },
    closeModal: () => {
      dispatch(actions.closeModal())
    },
    onClickReset: () => {
      dispatch(actions.reset())
      dispatch(actions.search())
    },
    onToggleAdvanced: (val) => {
      dispatch(actions.toggleAdvanced(val))
    },
    addDiamondClicked: (diamond) => {
      dispatch(cartActions.addDiamondsToCart([diamond]))
      dispatch(settingsActions.showCart())
    },
    clearCompareButtonClicked: () => {
      dispatch(actions.clearCompareData())
      dispatch(actions.closeModal())
    },
    swapCompareDataClicked: (pos1, pos2) => {
      dispatch(actions.swapCompareData(pos1, pos2))
    },
    removeItem: (item, items) => {
      dispatch(actions.removeItem(item))
      if (items.length === 1) {
        dispatch(actions.closeModal())
      }
    },
    search: () => {
      dispatch(actions.search())
    },
    getAllSuppliers: () => {
      dispatch(actions.getAllSuppliers())
    }
  }
}

class Search extends Component {
  componentDidMount () {
    this.props.search()
    // TODO - only update supplier list if current list is empty or > 24 hrs old
    this.props.getAllSuppliers()
  }

  render () {
    const props = this.props
    return (
      <div>
        <PageTitle title='Diamond Search'>Find the perfect diamond</PageTitle>

        <SearchFilters
          {...props.filters}
          suppliersList={props.suppliersList}
          advancedShown={props.advancedShown}
          onChangeVal={props.onChangeFilterVal}
          onClickReset={props.onClickReset}
          onSetDiamondTypeNatural={props.onSetDiamondTypeNatural}
          onSetDiamondTypeLabGrown={props.onSetDiamondTypeLabGrown}
          onToggleAdvanced={props.onToggleAdvanced} />

        <CompareModal
          isOpen={props.compareModalOpen}
          onRequestClose={props.closeModal}
          itemsToCompare={props.selectedItems}
          selectedDiamondPrices={props.selectedDiamondPrices}
          addableDiamonds={props.addableDiamonds}
          modalWidth={props.selectedItems.length}
          removeItem={props.removeItem}
          clearCompareButtonClicked={props.clearCompareButtonClicked}
          addDiamondClicked={(item) => props.addDiamondClicked(item)}
          swapCompareDataClicked={(pos1, pos2) => props.swapCompareDataClicked(pos1, pos2)} />

        <SearchResults />

        <Spacer xl />
      </div>
    )
  }
}

Search.propTypes = {
  suppliersList: PropTypes.array.isRequired,
  advancedShown: PropTypes.bool.isRequired,
  compareModalOpen: PropTypes.bool.isRequired,
  selectedItems: PropTypes.array.isRequired,
  selectedDiamondPrices: PropTypes.object.isRequired,
  addableDiamonds: PropTypes.array.isRequired,
  onChangeFilterVal: PropTypes.func.isRequired,
  onClickReset: PropTypes.func.isRequired,
  onToggleAdvanced: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  clearCompareButtonClicked: PropTypes.func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./src/containers/search.js